<template>
  <section class="advertiser-info">
    <b-row class="advertiser-info__summary">
      <b-col cols="12">
        <img
          :src="logoUrl"
          :alt="`Logotipo de ${campaign.name}`"
          class="d-block mx-auto"
        />
        <h2 class="advertiser-info__title text-center">Sobre o anunciante</h2>
        <p>{{ campaign.description }}</p>
      </b-col>
    </b-row>
    <b-row align-v="center" class="advertiser-info__payout">
      <b-col cols="6" lg="3" class="my-3">
        <div class="d-flex align-items-center">
          <img
            src="../assets/images/balance.svg"
            alt="Tipo de payout"
            class="advertiser-info__icon mr-2"
          />
          <div class="advertiser-info__content">
            <p class="advertiser-info__info-label font-weight-bold my-1">
              Tipo de Payout:
            </p>
            <p class="advertiser-info__info-value my-1">
              {{ campaign.commission_types }}
            </p>
          </div>
        </div>
      </b-col>
      <b-col cols="6" lg="3" class="my-3">
        <div class="d-flex align-items-center">
          <img
            src="../assets/images/money-bag.svg"
            alt="Payout máximo"
            class="advertiser-info__icon mr-2"
          />
          <div class="advertiser-info__content">
            <p class="advertiser-info__info-label font-weight-bold my-1">
              Payout máximo:
            </p>
            <p class="advertiser-info__info-value font-weight-normal my-1">
              {{ getAdvertiserPayout() }}
            </p>
            <b-button
              variant="grey"
              @click="openPayoutsModal()"
              @click.passive="track(`tabela de payout_${campaign.name}`)"
              class="show-payouts-btn"
              >Consulte a tabela</b-button
            >
          </div>
        </div>
      </b-col>
      <b-col cols="6" lg="3" class="my-3">
        <div class="d-flex align-items-center">
          <img
            src="../assets/images/notebook.svg"
            alt="Tempo de validade do cookie"
            class="advertiser-info__icon mr-2"
          />
          <div class="advertiser-info__content">
            <p class="advertiser-info__info-label font-weight-bold my-1">
              Tempo de validade do cookie:
              <span class="advertiser-info__info-value font-weight-normal">
                {{ campaign.commission_window }}
              </span>
            </p>
          </div>
        </div>
      </b-col>
      <b-col cols="6" lg="3" class="my-3 text-center">
        <div class="advertiser-info__rules p-3 d-flex align-items-center">
          <div class="advertiser-info__content">
            <p class="advertiser-info__info-label font-weight-bold my-1">
              Regras de divulgação
            </p>
            <p class="advertiser-info__info-value my-1">
              O descumprimento das regras pode causar o bloqueio
            </p>
            <b-button
              variant="orange"
              @click="openRulesModal()"
              @click.passive="
                track(`regras de divulgação_${campaign.name}`)
              "
              class="show-rules-btn"
              >Veja as regras</b-button
            >
          </div>
        </div>
      </b-col>
    </b-row>

    <b-modal
      class="advertiser-info__payouts"
      scrollable
      centered
      ref="payoutsModal"
      title="Payouts"
      :hide-footer="true"
    >
      <b-table
        :items="payouts"
      ></b-table>
    </b-modal>

    <b-modal
      scrollable
      centered
      ref="rulesModal"
      title="Regras de divulgação"
      modal-class="highlighted-modal advertiser-info__rules-modal"
    >
      <div
        class="advertiser-info__rules__content"
        v-html="pageAdvertiser.rules"
        v-if="pageAdvertiser"
      ></div>
      <div slot="modal-footer" class="w-100 d-flex justify-content-end">
        <b-button variant="orange" @click="closeRulesModal()">Fechar</b-button>
      </div>
    </b-modal>
  </section>
</template>

<script>
/* eslint-disable arrow-body-style */

import { mapGetters } from 'vuex';
import { isAdvertiserCustomPayout } from '@/utils/advertiserUtils';

export default {
  name: 'AdvertiserInfo',
  props: ['campaign', 'logoUrl'],
  computed: {
    payouts() {
      if (!this.pageAdvertiser || !this.pageAdvertiser.campaigns) return [];

      if (isAdvertiserCustomPayout(this.pageAdvertiser?.id) && this.pageAdvertiserCustom.length > 0) {
        return this.pageAdvertiser.campaigns
          .filter(campaign => campaign.active === 1)
          .map((campaign) => {
            let { payout } = campaign;
            const customAdvertiser = this.pageAdvertiserCustom
              .find((customValue) => { return customValue.IDT_CATEGORY === campaign.id; });

            if (customAdvertiser) {
              if (customAdvertiser.MAX_NUM_FEE_FIXED_VALUE > 0) {
                payout = this.formatCurrency(customAdvertiser.MAX_NUM_FEE_FIXED_VALUE);
              }

              if (customAdvertiser.MAX_PCT_COMMISSION > 0) {
                const percentage = this.formatPercentage(customAdvertiser.MAX_PCT_COMMISSION);

                if (customAdvertiser.MAX_NUM_FEE_FIXED_VALUE > 0) {
                  payout += ` ou ${percentage}`;
                } else {
                  payout = percentage;
                }
              }
            }

            return {
              campanha: campaign.name,
              payout,
            };
          });
      }

      return this.pageAdvertiser.campaigns
        .filter(campaign => campaign.active === 1)
        .map(campaign => ({
          campanha: campaign.name,
          payout: campaign.payout,
        }));
    },
    ...mapGetters(['pageAdvertiserCustom', 'pageAdvertiser']),
  },
  methods: {
    openPayoutsModal() {
      this.$refs.payoutsModal.show();
    },
    closePayoutsModal() {
      this.$refs.payoutsModal.hide();
    },
    openRulesModal() {
      this.$refs.rulesModal.show();
    },
    closeRulesModal() {
      this.$refs.rulesModal.hide();
    },
    stripOutTags(string) {
      if (!string) return '';
      return string.replace(/<\/?[^>]+>/g, '');
    },
    formatCurrency(value) {
      return value.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    },
    formatPercentage(value) {
      return `${value}%`;
    },
    toFloatValue(value) {
      return parseFloat(value.toString().replace(',', '.').replace('R$', ''));
    },
    getAdvertiserPayout() {
      if (isAdvertiserCustomPayout(this.pageAdvertiser?.id)) {
        const payoutCampigns = this.pageAdvertiser.campaigns.map((campaign) => {
          let { payout } = campaign;
          let percentagePayout = 0;
          const customAdvertiser = this.pageAdvertiserCustom
            .find((customValue) => { return customValue.IDT_CATEGORY === campaign.id; });

          if (customAdvertiser) {
            if (customAdvertiser.MAX_NUM_FEE_FIXED_VALUE > 0) {
              payout = this.toFloatValue(customAdvertiser.MAX_NUM_FEE_FIXED_VALUE);
            }

            if (customAdvertiser.MAX_PCT_COMMISSION > 0) {
              percentagePayout = this.toFloatValue(customAdvertiser.MAX_PCT_COMMISSION);
            }
          } else {
            payout = this.toFloatValue(payout);
          }

          return {
            percentage: percentagePayout,
            payout: this.toFloatValue(payout),
          };
        });

        const maxPercentage = payoutCampigns.reduce((prev, curr) => {
          return prev.percentage > curr.percentage ? prev : curr;
        });

        const maxPayout = payoutCampigns.reduce((obj, elem) => {
          return obj + elem.payout;
        }, 0);

        if (maxPercentage.percentage > 0) {
          return this.formatPercentage(maxPercentage.percentage);
        }

        return this.formatCurrency(maxPayout);
      }

      return this.stripOutTags(this.pageAdvertiser?.max_payout);
    },
  },
};
</script>

<style lang="scss" scoped>
.advertiser-info__title {
  font: Light 24px/28px UOLtext;
  color: $text-warning;
  margin: 0 0 30px 0;
}
.advertiser-info__description {
  font: Light 15px/20px UOLtext;
  color: #333333;
}
.advertiser-info__content {
  font: 14px/19px UOLtext;
  color: $text-dark;
}
.advertiser-info__rules {
  background-color: #ffeda0;
  @include rounded-medium();
}
</style>

<style lang="scss">
.advertiser-info__rules-modal .modal-dialog {
  max-width: 900px;
}
</style>
